$(document).ready(function () {

    $('[data-modal="certificado"]').on('click', function () {
        $('.overlay, #certificado').fadeIn('slow'); //при нажатии на кнопку появляется модальное окно
    });
    $('.modal-certificado_close').on('click', function () {
        $('.overlay, #certificado').fadeOut('slow'); //при нажатии на крестик закзрываю блок
    });

    $('[data-modal="donaciones"]').on('click', function () {
        $('.overlay, #donaciones').fadeIn('slow'); //при нажатии на кнопку появляется модальное окно
    });
    $('.modal-donaciones_close').on('click', function () {
        $('.overlay, #donaciones').fadeOut('slow'); //при нажатии на крестик закзрываю блок
    });

});


if (document.body.classList.contains('socio-popup')) {
    const errorPopup = document.querySelector('.error__popup');
    const closePopup = document.querySelector('.close');
    var modal = document.getElementById("errorModal");

    closePopup.addEventListener('click', () => {
        errorPopup.classList.toggle('hidden');
        modal.style.display = "none";
    });
}

tabs_on_resize();

window.onresize = tabs_on_resize;

function tabs_on_resize() {
    if (window.innerWidth > 1045) {
        document.querySelectorAll(".mobile__tabcontent").forEach(item => {
            // console.log(item.style.display)
            item.style.display = 'block'
        })
    } else {
        document.querySelectorAll(".mobile__tabcontent").forEach(item => {
            // console.log('none' + item)
            if (!item.classList.contains('opened_tab')) {
                item.style.display = 'none'
            }
        })
    }
}